import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminDteReportService {

  private url = environment.api + 'api/admin/dte/report';

  constructor(
      private http: HttpClient,
    ) { }

  getReconciliationReport(companyId: number, startDate: number, endDate: number, type: string) {
    return this.http.post(this.url+ "/reconciliation/" + companyId + "/" + startDate + "/" + endDate + "/" + type, null);
  }

  getReconciliationReportAllCompanies( startDate: number, endDate: number, type: string) {
    return this.http.post(this.url+ "/reconciliation/allCompanies/" + startDate + "/" + endDate + "/" + type, null);
  }
}
